import React from 'react';

/**
 * Datacrate brand mark — the small crate glyph used by the "Ask DAM" affordances,
 * the first-login landing, the sim wizard, and inline brand chips.
 *
 * An isometric crate (the LOCKED `BrandLogo` mark, simplified to a single-colour
 * line glyph) drawn with `stroke="currentColor"` so it inherits the surrounding
 * theme/text colour. Sizing is driven by `className` (e.g. `w-4 h-4`) exactly
 * like the lucide icons it sits beside, so it drops in without changing layout.
 */
export function DaMonogramIcon({
  className = '',
  size,
  ...rest
}: React.SVGProps<SVGSVGElement> & { size?: number | string }): React.JSX.Element {
  return (
    <svg
      {...(size !== undefined ? { width: size, height: size } : {})}
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.8}
      strokeLinejoin="round"
      strokeLinecap="round"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      {/* Sitemark — crate silhouette that doubles as a site/location pin, with a
          filled core. Monochrome (currentColor) so it sits inline with text. */}
      <path d="M15 8 H33 A7 7 0 0 1 40 15 V26 L24 41 L8 26 V15 A7 7 0 0 1 15 8 Z" />
      <circle cx="24" cy="21" r="3.2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export default DaMonogramIcon;
